
import { Directive, EventEmitter, HostListener, Input} from '@angular/core';
import { WInputTextBase } from '@wipo/w-angular/shared';

import { isArrowKey, isModifierKey, WOption, WOptionOrString } from '@wipo/w-angular/shared';

@Directive()
export abstract class WInputWDropdownDirective extends WInputTextBase {
  //  input-search i/o
  dropdownText: string = ''; // displays text in dropdown
  dropdownList: WOptionOrString[] = []; // displays as list in dropdown
  dropdownSelected: WOptionOrString[] = [];
  wDropdownClick = new EventEmitter<WOption | string>(); // click on dropdown list item

  // base for input-search and select-multi
  @Input() dropdownShow: boolean = false; // set false to hide, true allows to drop-down if we hv defined text or option list
  @Input() dropdownKeepOpen: boolean = false; // keep open after selection
  @Input() showWhenCleared: boolean = false; // allow show dropdown even if text cleared

  temp_keepClosedOnFocus: boolean = false; // temporary flag, to focus field without default action (opening dropdown)

  canShow: boolean = false;
  get hasDropdownContent() {
    return !!this.dropdownText || this.dropdownList.length > 0;
  }
  get showDropdown() {
    return !this.disabled && !!this.dropdownShow && (this.canShow || !!this.showWhenCleared) && this.hasDropdownContent;
  }

  override hasContent(): boolean {
    return false;
  }
  hasText(): boolean {
    return !!this.value;
  }
  getText(): string {
    return this.value;
  }
  clearText(): string {
    return this.value = '';
  }
  @HostListener('document:click', ['$event.target'])
  onClick(targetElement: HTMLElement) {
    const clickedInside = this._elementRef.nativeElement.contains(targetElement);
    if (!clickedInside) {
      this.canShow = false;
    }
  }
  clear() {
    this.hideDropdown();
    if (!this.dropdownKeepOpen && this.getText()) {
      this.clearText();
      this.wChange.emit('');
    }
  }
  
  hideDropdown() {
    if (!this.dropdownKeepOpen) {
      this.canShow = false;
      this.activeIndex = -1;
    }
  }
  processBlur(e: FocusEvent) {
    // simplified until just emit remains
    this.wBlur.emit(e);
  }

  keydown(event: KeyboardEvent) {
    // special treatment - arrows
    if (this.handleUpAndDown(event, this.dropdownList?.length)) {
      // handled in parent (common with other navigable dropdowns)
    } else if (event.key === 'Tab') {
      // this.canBlur = true;
    } else if (event.key === 'Enter') {
      if (this.showDropdown) {
        // emit selection
        if (this.dropdownList[this.activeIndex]) {
          this.wDropdownClick.emit(this.dropdownList[this.activeIndex]);
          // whenever we select in list we close it
          // unless specially
          this.hideDropdown();
        } else {
          this.wChange.emit(this.getText());
        }
      } else {
        // emit current value
        this.wChange.emit(this.getText());
      }
    } else {
      this.activeIndex = -1; // reset selection pointer
    }
  }
  keyup(event: KeyboardEvent) {
    if (!isModifierKey(event)) {
      if (event.key !== 'Enter') {
        const arrowUp = event.key === 'ArrowUp';
        const arrowDown = event.key === 'ArrowDown';
        const toShow = this.hasText() || !!this.showWhenCleared || !!this.dropdownKeepOpen || arrowDown || arrowUp;
        this.canShow = toShow;
      }
      if (!isArrowKey(event)) { this.wKeyup.emit(event); }
    }

  }
  dropdownClick(o: WOptionOrString) {
    this.activeIndex = this.dropdownList.indexOf(o);
    this.wDropdownClick.emit(o);
    this.hideDropdown();
    this.focus(true);
  }
  inputFocus(event: FocusEvent) {
    if (!this.temp_keepClosedOnFocus) {
      setTimeout(() => {
        this.canShow = this.hasText() || !!this.showWhenCleared || !!this.dropdownKeepOpen;
      });
    } else {
      this.temp_keepClosedOnFocus = false;
    }
    this.wFocus.emit(event);
  }
  override focus(keepClosed?: boolean) {
    super.focus();
    this.temp_keepClosedOnFocus = keepClosed ?? false;
  }
  clickSearch() {
    if (Array.isArray(this.dropdownList)) {
      this.canShow = !this.canShow;
    }
  }
}

